import { EPermissionGroup } from 'common/permissions.types';

export enum ESideBarChipType {
  COMING_SOON = 'coming_soon',
  NEW = 'new',
  LOCKED = 'locked'
}

export enum ESidebarGroupKey {
  Management = 'Management',
  Sdk = 'SDK',
  Studio = 'Studio',
  Offers = 'Offers',
  Dashboard = 'Dashboard',
  Projects = 'Projects',
  Stores = 'Stores',
  PortalStudio = 'Portal Studio'
}
export interface SideBarItem {
  title: string;
  url: string;
  icon: string | React.ReactNode;
  permissions?: EPermissionGroup[];
  chip?: ESideBarChipType;
  isDisabled?: boolean;
  docsLink?: string;
  onClick?: (e: React.MouseEvent) => void;
}

export interface SideBarGroup {
  title: ESidebarGroupKey;
  items: SideBarItem[];
  isCollapsable?: boolean;
  type?: ESideBarChipType;
}

export enum ESideBarContext {
  COMPANY = 'company',
  PROJECT = 'project',
  PORTAL = 'portal',
  PORTAL_LEVEL_STORE = 'store'
}

export interface ESideBarChipConfig {
  styles: string;
  title: string;
  disabledStateStyles?: string;
  tooltip?: string;
}
